import {
  Container,
  Grid,
  Box,
  Typography,
  styled,
  Paper,
  Stack,
} from "@mui/material";
import Co2Icon from "@mui/icons-material/Co2";
import ParkIcon from "@mui/icons-material/Park";
import AdjustIcon from "@mui/icons-material/Adjust";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import useMapImpactSlider from "hooks/maps/useMapImpactSlider";
import { selectReferenceExperience } from "redux/slices/shed/shedSlice";
import useMapShareTripParams from "hooks/maps/useMapShareTripParams";
import { useAppSelector } from "redux/hooks";
import AnimatedCounter from "components/core/AnimatedNumber";

const ImpactPaper = styled(Paper)(({ theme }) => ({
  borderRadius: 16,
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
}));

const MapEmbedCalculatorPage = () => {
  useMapShareTripParams();

  const mapExperience = useAppSelector(selectReferenceExperience);
  const {
    savedTrees,
    savedAreaKilometers,
    savedAreaSoccerFields,
    savedAreaMeters,
    savedCO2,
    logSliderInfo,
  } = useMapImpactSlider({
    mapExperience,
  });

  logSliderInfo(savedAreaMeters);

  return (
    <Container maxWidth="md" disableGutters sx={{ my: 2 }}>
      <Grid
        container
        rowSpacing={2}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Grid item xs={12} md={3}>
          <Stack alignItems="center" justifyContent="center" gap={2}>
            <ParkIcon color="success" fontSize="large" />
            <Typography variant="body2" color="text.secondary">
              Trær reddet
            </Typography>
            <Typography color="success.main" variant="h5">
              <AnimatedCounter value={savedTrees} />
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack gap={1}>
            <ImpactPaper elevation={5}>
              <Box display="flex" gap={1}>
                <AdjustIcon color="success" />
                <Typography>Område reddet (km²):</Typography>
                <Box flexGrow={1} />
                <Typography color="success.main" fontWeight={500}>
                  <AnimatedCounter value={savedAreaKilometers} />
                </Typography>
              </Box>
            </ImpactPaper>
            <ImpactPaper elevation={5}>
              <Box display="flex" gap={1}>
                <AdjustIcon color="success" />
                <Typography>Område reddet (m²):</Typography>
                <Box flexGrow={1} />
                <Typography color="success.main" fontWeight={500}>
                  <AnimatedCounter value={savedAreaMeters} />
                </Typography>
              </Box>
            </ImpactPaper>
            <ImpactPaper elevation={5}>
              <Box display="flex" gap={1}>
                <SportsSoccerIcon color="success" />
                <Typography>Fotballbaner reddet:</Typography>
                <Box flexGrow={1} />
                <Typography color="success.main" fontWeight={500}>
                  <AnimatedCounter value={Math.trunc(savedAreaSoccerFields)} />
                </Typography>
              </Box>
            </ImpactPaper>
          </Stack>
        </Grid>
        <Grid item xs={12} md={3}>
          <Stack alignItems="center" justifyContent="center" gap={2}>
            <Co2Icon color="success" fontSize="large" />
            <Typography variant="body2" color="text.secondary">
              CO2 reddet (tonn)
            </Typography>
            <Typography color="success.main" variant="h5">
              <AnimatedCounter value={savedCO2} />
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
};

export default MapEmbedCalculatorPage;
